import { HubConnectionBuilder, HubConnectionState } from "@microsoft/signalr";

class Socket {
  static #connection = null;
  static #pendingConnection = null;

  static async grabConnection(hubName = 'JackpotHub', config) {
    if (this.#pendingConnection) {
      await this.#pendingConnection;
      return this.#connection;
    }

    if (!this.#connection || this.#connection.state === HubConnectionState.Disconnected) {

      const url = `${config.jackpot.connectionUrl}/${hubName}?x-api-key=${encodeURIComponent(config.jackpot.apiKey)}`;

      const connection = new HubConnectionBuilder()
        .withUrl(url)
        .withAutomaticReconnect()
        .build();

      this.#pendingConnection = connection.start();

      try {
        await this.#pendingConnection;
        this.#connection = connection;
      } catch (err) {
        throw err;
      } finally {
        this.#pendingConnection = null;
      }
    }

    return this.#connection;
  }

  static async invoke(actionName, data, config) {
    if (!this.#connection) await this?.grabConnection(config);
    return this.#connection.invoke(actionName, data);
  }

  static async subscribeToJackpot(id, callback, config) {
    const connection = await this.grabConnection('jackpot', config);

    connection.off('NotifyAsync');
    connection.off('NotifyWinnerAsync');

    connection.on('NotifyAsync', (data) => {
      callback(data);
    });
    connection.on('NotifyWinnerAsync', (data) => {
      callback(data);
    });

    if (id) {
      try {
        await connection.invoke('OnJackpotUpdate', id);
      } catch (err) {
        console.error("Invoke failed:", err);
      }
    }
  }

  static async unsubscribeFromJackpot(config) {
    const connection = await this.grabConnection('jackpot', config);

    if (connection) {
      connection.off('NotifyAsync');
      connection.off('NotifyWinnerAsync');
      connection.off('OnJackpotUpdate');
    }
  }


  static async stopConnection() {
    if (this.#connection) {
      await this.#connection.stop();
      this.#connection = null;
    }
  }

}

export default Socket;
